import { render } from "./GeneralView.vue?vue&type=template&id=06013fbb"
import script from "./GeneralView.vue?vue&type=script&lang=js"
export * from "./GeneralView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__